var MpPageBulletinInsert;

(function() {
    if (!document.querySelector('#vue-body-bulletin-insert')) {
        return;
    }

    Vue.component('multiselect', window.VueMultiselect.default);
    Vue.component('file-upload', VueUploadComponent);
    Vue.component('flat-pickr', VueFlatpickr);

    MpPageBulletinInsert = new Vue({
        el: '#vue-body-bulletin-insert',

        data: {
            FORM_URL: '/bulletin/setNewAdvert',
            REMOVE_URL: '/server/uploads/delete.php',

            STEP_1: 0,
            STEP_2: 1,
            STEP_3: 2,

            RESPONSE_OK: 'OK',
            RESPONSE_KO: 'KO',
            VALIDATION_OK: 1,
            VALIDATION_KO: 0,

            DATE_PICKER_CONFIG: {
                defaultDate: new Date(),
                minDate: new Date(),
                dateFormat: 'Y-m-d',
                altInput: true,
                altFormat: 'd/m/Y',
                locale: 'es',
                shorthandCurrentMonth: true,
            },

            // Those global_ comes from Notes Controller PHP
            FORM_SUBMIT_FREE_ADV_TEXT: FORM_SUBMIT_FREE_ADV_TEXT,
            FORM_SUBMIT_NON_FREE_ADV_TEXT: FORM_SUBMIT_NON_FREE_ADV_TEXT,
            ADVERT_PERIOD_WORD: ADVERT_PERIOD_WORD,
            ADVERT_HIGHLIGHT_WORD: ADVERT_HIGHLIGHT_WORD,

            defaultAdvertPrevTitle: defaultAdvertPrevTitle,
            defaultAdvertPrevContent: defaultAdvertPrevContent,
            currentDate: currentDate,

            TXT_ACTION_DELETE: cancelUploadText,
            TXT_FAIL_UPLOAD: failUploadText,
            TXT_OK_UPLOAD: successUploadText,
            TXT_DRAG: dragFileText,

            categoryList: JSON.parse(CATEGORIES),
            periodList: JSON.parse(PERIODS),
            paymentList: JSON.parse(PAYMENTS),

            advertId: advertId,
            advertAction: advertAction,
            advertCode: advertCode,
            // End inject from PHP controller


            category: '', // category
            categoryName: '',
            period: '', // period
            periodName: '',
            publicationDate: '', // publication_date + publication_date_input
            title: '', // title
            description: '', // description
            content: '', // content
            files: [],
            image_1: null, // image1
            image_2: null, // image2
            image_3: null, // image3
            name: '', // user_name
            address: '', // user_address
            email: '', // user_email
            phone: '', // user_phone_1
            cell: '', // user_phone_2
            privacity: false, // terms_conditions_check

            isHighlighted: false, // highlight

            paymentType: '', // id_highlight_period
            paymentMode: '', // payment_mode
            fiscalId: '', // fiscal_id
            fiscalName: '', // name
            fiscalAddress: '', // address

            defaltPaymentType: -1,

            upload: null,

            successMessage: '',
            errorsFirstStep: [],
            errorsSecondStep: [],
            errorsThirdStep: [],
            validatedFirstStep: false,
            validatedSecondStep: false,
            validatedThirdStep: false,

            currentStep: 0,

            isSending: false,
            isLegalShown: false,
            isInitialized: false,
        },

        components: {
            FileUpload: VueUploadComponent
        },

        computed: {

            categoryCheck: function() {
                return !this.validatedFirstStep || !FormValidator.isEmpty(this.category);
            },

            publicationDateCheck: function() {
                return !this.validatedFirstStep || !FormValidator.isEmpty(this.publicationDate);
            },

            periodCheck: function() {
                return !this.validatedFirstStep || !FormValidator.isEmpty(this.period);
            },

            titleCheck: function() {
                return !this.validatedFirstStep || !FormValidator.isEmpty(this.title);
            },

            descriptionCheck: function() {
                return !this.validatedFirstStep || !FormValidator.isEmpty(this.description);
            },

            nameCheck: function() {
                return !this.validatedSecondStep || !FormValidator.isEmpty(this.name);
            },

            phonesCheck: function() {
                return !this.validatedSecondStep ||
                ((!FormValidator.isEmpty(this.phone) && FormValidator.isNumber(this.phone)) || 
                (!FormValidator.isEmpty(this.cell) && FormValidator.isNumber(this.cell)));
            },

            emailCheck: function() {
                return !this.validatedSecondStep || FormValidator.isValidEmail(this.email);
            },

            privacityCheck: function() {
                return (!this.validatedSecondStep || this.privacity);
            },

            fiscalIdCheck: function() {
                return !this.validatedThirdStep || !FormValidator.isEmpty(this.fiscalId);
            },

            fiscalNameCheck: function() {
                return !this.validatedThirdStep || !FormValidator.isEmpty(this.fiscalName);
            },

            fiscalAddressCheck: function() {
                return !this.validatedThirdStep || !FormValidator.isEmpty(this.fiscalAddress);
            },

            getPeriodInfo: function() {

                switch (parseInt(this.paymentType)) {
                    case 1: return this.ADVERT_PERIOD_WORD + ' ' + this.periodName;
                    case 2: return this.ADVERT_PERIOD_WORD + ' ' + this.getPeriodName(this.paymentType) + ' ' + ADVERT_HIGHLIGHT_WORD;
                    case 3: return this.ADVERT_PERIOD_WORD + ' ' + this.getPeriodName(this.paymentType) + ' ' + ADVERT_HIGHLIGHT_WORD;
                }
            },

            getSubmitLabel: function() {
                return (this.isHighlighted) ? this.FORM_SUBMIT_NON_FREE_ADV_TEXT : this.FORM_SUBMIT_FREE_ADV_TEXT;
            },

            dataAdvert: function() {
                var data = {
                    'category': this.category.id, // category
                    'period': this.period.id, // period
                    'publication_date': this.publicationDate, // publication_date + publication_date_input
                    'publication_date_input': this.publicationDate, // publication_date + publication_date_input
                    'title': this.title, // title
                    'description': this.description, // description
                    'content': this.content, // content
                    'image_1': (this.files[0]) ? this.files[0].safe_name : '', // image1
                    'image_2': (this.files[1]) ? this.files[1].safe_name : '', // image2
                    'image_3': (this.files[2]) ? this.files[2].safe_name : '', // image3
                    'user_name': this.name, // user_name
                    'user_address': this.address, // user_address
                    'user_email': this.email, // user_email
                    'user_phone_1': this.phone, // user_phone_1
                    'user_phone_2': this.cell, // user_phone_2
                    'terms_conditions_check': (this.privacity) ? 1 : 0, // terms_conditions_check
                    'highlight': (this.isHighlighted) ? 1 : 0, // highlight
                    'id_highlight_period': this.paymentType,
                    'payment_mode': (this.isHighlighted) ? this.paymentMode.id : null, // payment_mode
                    'fiscal_id': this.fiscalId, // fiscal_id
                    'name': this.fiscalName, // name
                    'address': this.fiscalAddress, // address
                };

                if (this.advertId) {
                    data.advert_id = this.advertId;
                    data.security_code = this.advertCode;
                }

                return Serializer.serialize(data);
            },

        },

        methods: {

            getStepStyles: function(step) {
                var stepErrors;

                switch (step) {
                    case this.STEP_1:
                        stepErrors = this.errorsFirstStep;
                    break;
                    case this.STEP_2:
                        stepErrors = this.errorsSecondStep;
                    break;
                    case this.STEP_3:
                        stepErrors = this.errorsThirdStep;
                    break;
                }

                return {
                    'advert-form__progress-item--current': this.currentStep === step,
                    'advert-form__progress-item--validated': (this.currentStep > step && !stepErrors.length),
                };
            },

            getPeriodName: function(idPeriod) {
                var i = 0,
                    found = false;

                while (!found && i<this.periodList.length) {
                    if (parseInt(this.periodList[i].id) === parseInt(idPeriod)) {
                        found = true;
                    } else {
                        i++;
                    }
                }

                return (found) ? this.periodList[i].name : '';
            },

            sizeKb: function(bytes) {
                return (bytes/1024).toFixed(2);
            },

            closeLegalModal: function() {
                noScroll.off();
                this.isLegalShown = false;
            },

            showLegalConditions: function(ev) {
                if (ev.target.tagName === 'A') {
                    ev.preventDefault();
                    noScroll.on();
                    this.isLegalShown = true;
                }
            },

            setHighlight: function(value) {
                this.paymentType = parseInt(value);
                this.isHighlighted = (this.paymentType > 1);
            },

            getErrorList: function(step) {
                switch(step) {
                    case this.STEP_1: return this.errorsFirstStep;
                    case this.STEP_2: return this.errorsSecondStep;
                    case this.STEP_3: return this.errorsThirdStep;
                }
            },

            cleanErrors: function(step) {
                var errorList = this.getErrorList(step);
                errorList.splice(0, errorList.length);
            },

            addError: function(step, errorMsg) {
                if (this.getErrorList(step).length > 0) {
                    return;
                }

                this.getErrorList(step).push(errorMsg);
            },

            validateFirstStep: function() {
                // error messages are injected from BulletinContorller php
                var isValid = true;

                this.cleanErrors(this.STEP_1);
                this.validatedFirstStep = true;

                if (!this.categoryCheck) {
                    isValid = false;
                    this.addError(this.STEP_1, requiredFieldEmpty);
                }

                if (!this.publicationDateCheck) {
                    isValid = false;
                    this.addError(this.STEP_1, requiredFieldEmpty);
                }

                if (!this.periodCheck) {
                    isValid = false;
                    this.addError(this.STEP_1, requiredFieldEmpty);
                }

                if (!this.titleCheck) {
                    isValid = false;
                    this.addError(this.STEP_1, requiredFieldEmpty);
                }

                if (!this.descriptionCheck) {
                    isValid = false;
                    this.addError(this.STEP_1, requiredFieldEmpty);
                }

                return isValid;
            },

            validateSecondStep: function() {
                // error messages are injected from BulletinContorller php
                var isValid = true;

                this.cleanErrors(this.STEP_2);
                this.validatedSecondStep = true;

                if (!this.nameCheck) {
                    isValid = false;
                    this.addError(this.STEP_2, requiredFieldEmpty);
                }

                if (!this.emailCheck) {
                    isValid = false;
                    this.addError(this.STEP_2, emailFormatField);
                }

                if (!this.phonesCheck) {
                    isValid = false;
                    this.addError(this.STEP_2, phonesEmpty);
                }

                if (!this.privacityCheck) {
                    isValid = false;
                    this.addError(this.STEP_2, termsConditionsRequired);
                }

                return isValid;
            },

            validateThirdStep: function() {
                // error messages are injected from BulletinContorller php
                var isValid = true;

                if (this.isHighlighted) {
                    this.cleanErrors(this.STEP_3);
                    this.validatedThirdStep = true;

                    if (!this.fiscalIdCheck) {
                        isValid = false;
                        this.addError(this.STEP_3, requiredFieldEmpty);
                    }

                    if (!this.fiscalNameCheck) {
                        isValid = false;
                        this.addError(this.STEP_3, requiredFieldEmpty);
                    }

                    if (!this.fiscalAddressCheck) {
                        isValid = false;
                        this.addError(this.STEP_3, requiredFieldEmpty);
                    }
                }

                return isValid;
            },

            validateForm: function(step) {
                var isValid;

                switch (step) {
                    case this.STEP_1: isValid = this.validateFirstStep(); break;
                    case this.STEP_2: isValid = this.validateSecondStep(); break;
                    case this.STEP_3: isValid = this.validateThirdStep(); break;
                }

                return isValid;
            },

            onCategorySelected: function(category) {
                if (!category) {
                    return;
                }

                this.categoryName = category.name;
            },

            onPeriodSelected: function(period) {
                if (!period) {
                    this.period = this.periodList[0];
                    return;
                }

                this.periodName = period.name;
            },

            onPaymentModeSelected: function(payment) {
                // TODO: algo?
            },

            onDateChange: function(d) {
                // console.log(d);
            },

            onRemoveFile: function(response) {
                if (response.status !== 200) {
                    console.log('Error: '+response.statusText);
                }
            },

            removeFile: function(file) {
                axios
                    .post(this.REMOVE_URL, Serializer.serialize({'name': file.name}))
                    .then(this.onRemoveFile)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            inputFile: function (newFile, oldFile) {
                // https://lian-yue.github.io/vue-upload-component/#/en/documents#options-events-input-file

                if (newFile && oldFile) {

                    // new upload
                    if (!newFile.active && oldFile.active) {

                        if (!newFile.xhr || newFile.xhr.status !== 200) {
                            console.log('Error peticion Xhr');
                            return;
                        }

                        var fileInfo;
                        try {
                            fileInfo = JSON.parse(newFile.response).files[0];

                            if (fileInfo.error) {
                                newFile.success = false;
                                newFile.error = fileInfo.error;
                                return;
                            }

                            newFile.safe_name = fileInfo.safe_name;
                        } catch (error) {
                            newFile.success = false;
                            newFile.error = this.TXT_FAIL_UPLOAD;
                        }
                    }
                }

                // Remove file
                if (!newFile && oldFile && oldFile.success) {
                    this.removeFile(oldFile);
                }

                // Autoupload file
                if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
                    if (!this.upload.active) {
                        this.upload.active = true;
                    }
                }
            },

            resetForm: function() {
                this.origin = '';
                this.detail = '';
                this.link = '';
                this.author = '';
                this.email = '';
                this.privacity = false;

                this.fileUploaded = '';
                this.fileName = '';
                this.upload.clear();

                this.validated = false;
                this.cleanErrors();
            },

            initPublicationDate: function() {
                this.publicationDate = (this.$refs.publication_date.getAttribute('data-init')) ? this.$refs.publication_date.getAttribute('data-init') : new Date();
            },

            onInsert: function(response) {
                var _form,
                    _input;

                this.isSending = false;

                if (!response || (response.data.result !== this.RESPONSE_OK)) {
                    window.location.href = response.data.koUrl;
                    return;
                }

                if (response.data.okUrl) {
                    window.location.href = response.data.okUrl;
                    return;
                }

                if (!response.data.tpv_url) {
                    // old: !response || !this.isHighlighted() || this.paymentMode != 1
                    return;
                }

                _form = document.createElement('form');
                _form.setAttribute('method', 'post');
                _form.setAttribute('action', response.data.tpv_url);

                for (var key in response.data.tpv_data) {
                    _input = document.createElement('input'); //input element, text
                    _input.setAttribute('type', 'hidden');
                    _input.setAttribute('name', key);
                    _input.setAttribute('value', response.data.tpv_data[key]);
                    _form.appendChild(_input);
                }

                document.getElementsByTagName('body')[0].appendChild(_form);
                _form.submit();
            },

            insertAdvert: function() {
                this.isSending = true;

                axios
                    .post(this.FORM_URL, this.dataAdvert)
                    .then(this.onInsert)
                    .catch(function(error) {
                        console.log(error);
                    });
            },

            gotoStep: function(event) {
                var step = parseInt(event.target.getAttribute('data-step'));

                if (step === this.currentStep) {
                    return;
                }

                var stepJump = step - this.currentStep;

                for (var i=0; i<stepJump; i++) {
                    if (!this.validateForm(this.currentStep + i)) {
                        return;
                    }
                }

                this.currentStep = step;
            },

            nextStep: function() {
                if (this.validateForm(this.currentStep)) {
                    this.currentStep++;
                }

                if (!this.isSending && this.currentStep > this.STEP_3) {
                    this.insertAdvert();
                }
            },

            previousStep: function() {
                this.currentStep--;
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;
                Vue.nextTick(this.initPublicationDate);
            },
        },
        filters: {},

        mounted: function() {

            // TODO: valor inicial de period y cateogry en base a su option selected true

            this.title = this.$refs.title.getAttribute('data-init');
            this.description = this.$refs.description.getAttribute('data-init');
            this.content = this.$refs.content.getAttribute('data-init');
            this.name = this.$refs.name.getAttribute('data-init');
            this.address = this.$refs.address.getAttribute('data-init');
            this.email = this.$refs.email.getAttribute('data-init');
            this.phone = this.$refs.phone.getAttribute('data-init');
            this.cell = this.$refs.cell.getAttribute('data-init');
            this.privacity = this.$refs.privacity.getAttribute('data-init') === '1';

            this.upload = this.$refs.upload;

            this.defaultPaymentType = parseInt(this.$refs.defaultPaymentType.getAttribute('data-period'));
            this.paymentType = this.defaultPaymentType;

            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },
    });

})();
